import tagTester from './_tagTester.js';

export default tagTester('Date');



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/isDate.js
// module id = 1894
// module chunks = 1